import ApplicationController from '../application_controller.js'
import axios from 'axios'
import State from './state.js'

export default class IndexController extends ApplicationController {

  connect() {
    State.editor_opened = false
  }

  new_form(e) {
    e.preventDefault()

    if (!State.editor_opened) {
      axios.get(e.target.getAttribute('href')).then(response => {
        const tbody = document.querySelector("#filtered_table tbody");
        const newRow = tbody.insertRow(0);
        newRow.outerHTML = response.data
        State.editor_opened = true
      })
    }
  }

}